export const UPLOAD_PRODUCTS_COLUMNS_FM = {
    BARCODE:           'Código de barras',
    PRESENTATION:      'Presentación*',
    SUBCATEGORY:       'Subcategoría*',
    NAME:              'Nombre del producto*',
    ABBREVIATION:      'Abreviatura*',
    DESCRIPTION:       'Descripción del producto*',
    EXTERNAL_ID:       'ID externo(SKU)',
    ITEM_MASTER_SKU:   'Ítem master',
    UNIT_WEIGHT:       'Unidad de peso*',
    WEIGHT:            'Peso*',
    UNIT_DIMENSIONS:   'Unidad (dimensiones)*',
    WIDTH:             'Ancho*',
    HEIGHT:            'Alto*',
    LENGTH:            'Largo*',
    RECEIPT_UNIT_MEASURE: 'Unidad de medida para recibo',
    DISPATCH_UNIT_MEASURE: 'Unidad de medida para despacho',
    PRICE_PER_UNIT:    'Costo por unidad*',
    COMMERCIAL_PRICE:  'Valor comercial*',
    SHELF_LIFE_DAYS:   'Vida útil',
    MAX_DISPATCH_DAYS: 'Plazo máximo para despachar (días)',
};

export const UPLOAD_PRODUCTS_COLUMNS_NON_FM = {
    BARCODE:           'Código de barras',
    PRESENTATION:      'Presentación',
    SUBCATEGORY:       'Subcategoría',
    NAME:              'Nombre del producto*',
    ABBREVIATION:      'Abreviatura*',
    DESCRIPTION:       'Descripción del producto*',
    EXTERNAL_ID:       'ID externo(SKU)',
    ITEM_MASTER_SKU:   'Ítem master',
    UNIT_WEIGHT:       'Unidad de peso',
    WEIGHT:            'Peso',
    UNIT_DIMENSIONS:   'Unidad (dimensiones)',
    WIDTH:             'Ancho',
    HEIGHT:            'Alto',
    LENGTH:            'Largo',
    RECEIPT_UNIT_MEASURE: 'Unidad de medida para recibo',
    DISPATCH_UNIT_MEASURE: 'Unidad de medida para despacho',
    PRICE_PER_UNIT:    'Costo por unidad',
    COMMERCIAL_PRICE:  'Valor comercial',
    SHELF_LIFE_DAYS:   'Vida útil',
    MAX_DISPATCH_DAYS: 'Plazo máximo para despachar (días)',
};

export const getProductsColumnsForServiceType = (serviceType) => {
    const isFM = !serviceType || serviceType === 'FM';
    return isFM ? UPLOAD_PRODUCTS_COLUMNS_FM : UPLOAD_PRODUCTS_COLUMNS_NON_FM;
};

export const getProductsHeadersForServiceType = (serviceType) => {
    const columns = getProductsColumnsForServiceType(serviceType);
    return Object.values(columns).join(';');
};

export const handleDownloadTemplateBulkProducts = (serviceType) => {
    const fileName = 'Plantilla-cargue-de-productos.csv';
    const headers = getProductsHeadersForServiceType(serviceType);
    const blob = new Blob([headers], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
